// extracted by mini-css-extract-plugin
export var accordion = "_ij-0";
export var chevron = "_ij-3";
export var closed = "_ij-2";
export var content = "_ij-4";
export var open = "_ij-1";
export var rotate = "_ij-5";